import { ChangeDetectionStrategy, Component, OnInit, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { ReportService } from 'src/app/services/report.service';
import { UserService } from 'src/app/services/user.service';
import { DialogService } from 'src/app/services/dialog.service';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';

@Component({
  selector: 'app-view-wo-officer',
  templateUrl: './view-wo-officer.component.html',
  styleUrls: ['./view-wo-officer.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})


export class ViewWOOfficerComponent implements OnInit {

  regionContacts: any[] = [];
  report = input.required<any>();

  constructor(
    public dialog: MatDialog,
    public readonly reportService: ReportService,
    public readonly userService: UserService,
    public readonly dialogService: DialogService,
    public readonly toast: ConfirmationToastComponent,
  ) { }

  ngOnInit(): void {
    this.loadUsers();
  }

  loadUsers() {
    let roSign = this.report().signatures?.filter((signature: any) => signature.signature_type_id == 2);
    roSign.forEach((ro: any) => {
      if (ro.user_id)
        this.userService.getUser(ro.user_id).subscribe((user: any) => {
          // 18-wo Line Officer
          // 19-Acting wo Line Officer
          user.users[0].isWOLO = user.users[0].baer_roles.find((obj: any) => [18, 19].includes(obj.baer_role.value))
          this.regionContacts.push(user.users[0]);
        })
    })
  }
}
